<template>
  <div>
    <v-layout row v-if="bol.Location">
      <v-flex xs6>

      </v-flex>
      <v-flex xs6>
        <v-layout row>
          <v-flex xs12>
            <v-autocomplete single-line v-on:change="updateFacility"
              :value='bol.facilityId'
              :items='facilities'
              item-text='name'
              item-value='id'
              return-object
              label='Facility'
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            Bond:
          </v-flex>
          <v-flex xs8>
            {{ bol.Location.bondNumber }}
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            Address 1:
          </v-flex>
          <v-flex xs8>
            {{ bol.Location.address1 }}
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            Address 2:
          </v-flex>
          <v-flex xs8>
            {{ bol.Location.address2 }}
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            City/State/Zip
          </v-flex>
          <v-flex xs8>
            {{ bol.Location.city }}, {{bol.Location.state}} {{bol.Location.zip}}
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs6 v-if="bol.Location.id">
        <v-layout row>
          <GmapMap
            :center="marker"
            :zoom="11"
            map-type-id="terrain"
            style="width: 500px; height: 300px"
          >
            <GmapMarker
              :position="marker"
              :clickable="true"
              :draggable="true"
              @click="center=marker"
            />
          </GmapMap>
        </v-layout>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'

export default {
  props: ['bol'],
  data () {
    return {
      geoCodedAddress: {}
    }
  },
  mixins: [myMixins],
  created () {
  },
  computed: {
    marker () {
      let result = { lat: this.geoCodedAddress.latitude, lng: this.geoCodedAddress.longitude }
      if (result.lat) {
        return result
      } else {
        return { lat: 36.6248006, lng: -121.591403 }
      }
    },
    facilities () {
      return this.$store.state.facilities
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    updateFacility (value) {
      this.bol.facilityId = value.id
      // this.bol.Location = value
      // this.getLatLong()
      let url = process.env.VUE_APP_BACKEND + 'locations/' + value.id
      axios
        .get(url)
        .then(response => {
          let loc = response.data[0]
          this.bol.Location['bondNumber'] = loc.bondNumber
          this.bol.Location['address1'] = loc.address1
          this.bol.Location['address2'] = loc.address2
          this.bol.Location['city'] = loc.city
          this.bol.Location['state'] = loc.state
          this.bol.Location['zip'] = loc.zip
          this.bol.Location['id'] = value.id
          this.$emit('facilityChanged')
        })
    },
    getLatLong () {
      const address = "'" + this.bol.Location.address1 + ' ' + this.bol.Location.city + ' ' + this.bol.Location.state + "'"
      axios
        .get(process.env.VUE_APP_BACKEND+'geocoder?address=' + address)
        .then(response => {
          this.geoCodedAddress = response.data[0]
          this.geoCodedAddress.lat = this.geoCodedAddress.latitude
          this.geoCodedAddress.lng = this.geoCodedAddress.longitude
        })
    }
  }
}
</script>
<style>
</style>
